import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from '../../store';

import LineInp from '../common/input';
import { isInteger } from '../../common/common';
import { saveEditDetails, toggleFinalSave } from '../../actions/editPolicy-actions';

class ComDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
            PaxMobile:'',
            PaxEmail:'',
            countryCode:'+91',
            comDetails:true
        };
    }

    componentDidMount() {
        let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        let PaxEmail = APIGetBookingDetailsResult.PassengerEmail;
        let PaxMobile = APIGetBookingDetailsResult.PassengerContactNo1;
        this.setState({PaxEmail,PaxMobile});
    }

    comDetails = () => {
        let allowEdit = this.props.editPolicy.filter;
        return(
            <div>
                <div className='top-wrapper' style={{background: window.color['searchBoxBgColor']}}>
                    <span className='back-arrow' onClick = { () => { this.props.closeSlider('comDetails',false);store.dispatch(toggleFinalSave(false)) } } >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"/>
                        </svg>
                    </span>
                    <span className='header-title'>
                        Contact Detail
                    </span>
                </div>
                <div className='ep-wrapper' style={{zIndex:'9'}}>
                    <div className='comDetails-wrapper'>
                        {  allowEdit.IsPaxPhoneEdit && 
                            <LineInp 
                                style = {{display:'inline-block',width:'50px',padding:'15px 10px 15px 0px',boxSizing:'border-box'}}
                                type = 'text'
                                value = { this.state.countryCode }
                                handleChange = { (e) => { isInteger(e.target.value) && this.setState({ countryCode:e.target.value }) }}
                                name = 'countrycode'
                                max = { 8 }
                            />
                        }
                        {  allowEdit.IsPaxPhoneEdit && 
                            <LineInp 
                                style = {{display:'inline-block',width:'calc(100% - 50px)',boxSizing:'border-box'}}
                                type = 'tel'
                                value = { this.state.PaxMobile }
                                handleChange = { (e) => { isInteger(e.target.value) && this.setState({ PaxMobile:e.target.value }) }}
                                placeholder = 'Mobile No'
                                name = 'mobileNo'
                            /> 
                        }    
                        {  allowEdit.IsPaxEmailEdit &&  
                            <LineInp 
                                type = 'text'
                                value = { this.state.PaxEmail }
                                handleChange = { (e) => this.setState({ PaxEmail : e.target.value }) }
                                placeholder = 'Email ID'
                                name = 'email'
                                style = {{ width: '100%' }}
                            />
                        }
                        <div className='btn' style={{ 
                            position:'fixed', left:'0', 
                            bottom:'0', 
                            background: this.state.PaxMobile ? window.color['buttonColor']:'#ddd'
                        }} 
                            onClick={ ()=>this.state.PaxMobile ? this.checkEditOption():'' }>
                            PROCEED
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    getMobile = () => {
        let mob = this.state.PaxMobile.replace(/\-/g, '');
        const mobNo = this.state.countryCode === '+91' ? mob : this.state.countryCode+mob;
        return mobNo;
    }

    checkEditOption = () => {
        let editDetails = this.props.editPolicy.editDetails;

        let passEmail = this.state.PaxEmail;
        let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(passEmail.trim());
        email ? (editDetails['PaxEmail'] = this.state.PaxEmail) : alert('Please enter correct email id');

        let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);

        let indianMobNo = (this.state.PaxMobile + '').length === 10 && /^[0]?[6789]\d{9}$/.test(this.state.PaxMobile);
        let internationalNo = (this.state.PaxMobile + '').length < 20 && /^[0-9\-]+$/.test(this.state.PaxMobile);
        let mobile = (countryCode && this.state.countryCode === '+91') ? indianMobNo : internationalNo;
        mobile ? (editDetails['PaxMobile'] = this.getMobile()) : alert('Please enter correct mobile no');

        if(countryCode && email && mobile){
            store.dispatch(saveEditDetails(editDetails));

            const editOptions = this.props.editPolicy.editOptions;
            let flag =0;
            for (var i = 0; i < editOptions.length; i++) {
                let el = editOptions[i];
                if(el.value === 'on' && el.name !== 'seatChart' && el.name !== 'pickUp' && el.name !== 'dropOff' && el.name !== 'passDetails' && el.name !== 'comDetails') {
                    this.setState({ [el.name]:true});
                    flag =1;
                    break;
                }
            }

            if(flag === 0) {
                store.dispatch(toggleFinalSave(true)); 
            }
        }
    }

	render() {
    	return (
            <div>
                { this.state.comDetails && this.comDetails() }
			</div>
    	);
  	}
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(ComDetails);


// WEBPACK FOOTER //
// ./src/components/comDetails/ComDetails.js